<template>
  <div class="container">
    <Header :title="'在线纪念'" />
    <div class="titleBox">{{ info.title }}</div>
    <div class="titleLine" />
    <div class="infoBox">
      <div class="info-item">
        <span class="key">日期：</span>
        <span class="value">{{ info.updatedDate }}</span>
      </div>
      <div class="info-item">
        <span class="key">浏览：</span>
        <span class="value">{{ info.browseTimes }}</span>
      </div>
    </div>
    <div class="richText" v-html="info.content" />
    <div v-show="info.isComment" class="buttonBox" @click="showContent = !showContent">
      <nut-button>发表评论</nut-button>
    </div>
    <div v-show="showContent" class="formBox">
      <nut-textbox v-model="content" :txt-area-h="100" :max-num="100" switch-max :place-text="'发表评论'" />
      <div class="submit">
        <nut-button @click="submitContent">提交</nut-button>
      </div>
    </div>
    <div class="commentBox">
      <div class="title">文章评论(共{{ total }}条)</div>
      <div class="listBox">
        <div v-for="item of commentList" :key="item.id" class="comment-item">
          <div class="top-com">{{ item.content }}</div>
          <div class="bottom-com">
            <div class="avaName flex-row-center-center">
              <img v-if="item.memberAvatar" :src="$resUrl(item.memberAvatar)" alt>
              <img v-if="!item.memberAvatar" src="@/assets/images/avatar-default.png" alt>
              <span class="name">{{ item.name }}</span>
            </div>
            <span>{{ item.createdDate }}</span>
          </div>
        </div>
      </div>
    </div>
    <!-- 分页 -->
    <div v-show="commentList.length" class="pagination">
      <van-pagination
        v-model="pageIndex"
        :total-items="total"
        :show-page-size="3"
        :items-per-page="pageSize"
        force-ellipses
        @change="pageChange"
      />
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { Pagination } from 'vant'
import { GetArticleDetail, GetArticleComment, AddArticleComment } from '@/api/Hall/index'
import { Toast } from '@nutui/nutui'
import Header from '@/components/Header/Index'

Vue.use(Pagination)

export default {
  name: 'ArticleShow',
  components: {
    Header
  },
  data() {
    return {
      id: '',
      info: {},
      commentList: [],
      pageIndex: 1,
      pageSize: 5,
      total: 0,
      content: '',
      showContent: false
    }
  },
  mounted() {
    this.id = this.$route.query.id
    this.getDetail()
    this.getComments()
  },
  methods: {
    getDetail() {
      GetArticleDetail(this.id).then(res => {
        res.data.updatedDate = res.data.updatedDate.split(' ')[0]
        this.info = res.data
      })
    },
    getComments() {
      const params = {
        id: this.id,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize
      }
      GetArticleComment(params).then(res => {
        this.total = res.data.total
        res.data.rows.forEach(item => {
          item.createdDate = item.createdDate.split(' ')[0]
          item.createdDate = item.createdDate.replace(/-/g, '/')
        })
        this.commentList = res.data.rows
      })
    },
    pageChange() {
      this.getComments()
    },
    submitContent() {
      if (this.content === '') {
        Toast.text('评论不能为空')
        return
      }
      const params = {
        id: this.id,
        content: this.content
      }
      AddArticleComment(params).then(res => {
        if (res.success) {
          Toast.success('评论成功！')
          this.content = ''
          this.getComments()
        } else {
          Toast.fail(res.msg)
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  padding: 15px;

  .titleBox {
    padding: 15px 0px;
    line-height: 1.5;
  }

  .titleLine {
    width: 50px;
    height: 3px;
    background: $primary-color;
  }

  .infoBox {
    margin-top: 12px;
    margin-bottom: 20px;

    .info-item {
      display: inline-block;
      font-size: 12px;
      margin-right: 25px;

      .key {
        color: #666;
      }

      .value {
        color: #999;
      }
    }
  }

  .richText {
    ::v-deep img {
      max-width: 100%;
      height: auto !important;
    }

    ::v-deep p {
      word-break: break-word;
    }

    ::v-deep .ql-align-center {
      text-align: center;
    }

    ::v-deep .ql-align-left {
      text-align: left;
    }

    ::v-deep .ql-align-right {
      text-align: right;
    }

    ::v-deep .ql-align-justify {
      text-align: justify;
    }
  }

  .buttonBox {
    text-align: center;
    margin-top: 30px;

    .nut-button {
      // width: 100%;
      background: $primary-color;
      font-size: 18px;
      border-radius: 5px;
    }
  }

  .formBox {
    margin-top: 30px;

    .submit {
      margin-top: 15px;
      text-align: right;

      .nut-button {
        background: $primary-color;
        padding: 0px 25px;
        border-radius: 4px;
      }
    }
  }

  .commentBox {
    margin-top: 40px;

    .title {
      font-size: 14px;
      color: #464646;
      margin-bottom: 10px;
    }

    .listBox {
      .comment-item {
        padding: 12px 0px;
        border-bottom: 1px solid #e6e6e6;

        .top-com {
          font-size: 12px;
          word-break: break-all;
        }

        .bottom-com {
          margin-top: 10px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          font-size: 10px;
          color: #afafaf;
          padding-right: 6px;
          .avaName {
            img {
              width: 20px;
              height: 20px;
              margin-right: 6px;
              border-radius: 50%;
            }
            .name {
              margin-right: 10px;
            }
          }
        }
      }
    }
  }

  .pagination {
    padding: 15px;

    .van-pagination {
      margin-bottom: 30px;
      justify-content: center;

      ::v-deep .van-pagination__item {
        color: #555;
        border-radius: 5px;
        margin: 0 3px;
        font-weight: bold;
        height: 35px;
      }

      ::v-deep .van-pagination__item::after {
        display: none;
      }

      ::v-deep .van-pagination__item:disabled {
        background: #fff;
        opacity: 1;
        color: #ddd;
      }

      ::v-deep .van-pagination__item:active {
        background-color: $primary-color-bright;
        color: #fff;
      }

      ::v-deep .van-pagination__item--disabled {
        background: #fff;
        opacity: 1;
        color: #ddd;
      }

      ::v-deep .van-pagination__item--active {
        background-color: #fff;
        color: $primary-color;
      }

      ::v-deep .van-pagination__prev {
        max-width: 150px;
      }

      ::v-deep .van-pagination__next {
        max-width: 150px;
      }
    }
  }
}
</style>
